import { createAction, props } from '@ngrx/store';

import { Measurement, MeasurementSummary } from '../models/measurements.model';

export const loadMeasurementOverviewRequest = createAction(
  '[Measurements] Load measurement overview request',
);

export const loadMeasurementOverviewSuccess = createAction(
  '[Measurements] Load measurement overview success',
  props<{ measurementOverview: MeasurementSummary[] }>(),
);

export const loadMeasurementRequest = createAction(
  '[Measurements] Load measurement request',
  props<{ measurementId: number }>(),
);

export const loadMeasurementSuccess = createAction(
  '[Measurements] Load measurement success',
  props<{ measurement: Measurement }>(),
);

export const addMeasurementRequest = createAction(
  '[Measurements] Add measurement request',
  props<{ measurement: Measurement }>(),
);

export const addMeasurementSuccess = createAction(
  '[Measurements] Add measurement success',
  props<{ measurement: Measurement }>(),
);

export const updateMeasurementRequest = createAction(
  '[Measurements] Upsert measurement request',
  props<{ measurement: Measurement }>(),
);

export const updateMeasurementSuccess = createAction(
  '[Measurements] Upsert measurement success',
  props<{ measurement: Measurement }>(),
);

export const deleteMeasurementRequest = createAction(
  '[Measurements] Delete measurement request',
  props<{ measurementId: number }>(),
);

export const deleteMeasurementSuccess = createAction(
  '[Measurements] Delete measurement success',
  props<{ measurementId: number }>(),
);

export const initializeMeasurementRequest = createAction(
  '[Measurements] Initialize measurement request',
);

export const initializeMeasurementSuccess = createAction(
  '[Measurements] Initialize measurement success',
  props<{ measurement: Measurement }>(),
);

export const copyMeasurementRequest = createAction(
  '[Measurements] Copy measurement request',
  props<{ existingMeasurementSummaryId: number }>(),
);

export const copyMeasurementSuccess = createAction(
  '[Measurements] Copy measurement success',
  props<{ measurement: Measurement }>(),
);

export const calculateMeasurementRequest = createAction(
  '[Measurements] Calculate measurement request',
  props<{ measurement: Measurement }>(),
);

export const calculateMeasurementSuccess = createAction(
  '[Measurements] Calculate measurement success',
  props<{ measurement: Measurement }>(),
);

export const clearMeasurement = createAction('[Measurements] Clear measurement');
export const clearMeasurementOverview = createAction('[Measurements] Clear measurement overview');
